import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  formControl: {
    [`& fieldset`]: {
      borderRadius: '5px'
    }
  }
}));
